module.exports = __webpack_public_path__ + "static/media/LP-app-store.917f0ba2.svg";